import shoelaceStyles from '../styles/shoelaceStyles';
import styles from '../styles/styles.scss';
import {css, html, LitElement} from 'lit';
import {customElement} from 'lit/decorators.js';
import {log} from '../controllers/LogController';
import {SearchController} from '../controllers/SearchController';
import {when} from 'lit/directives/when.js';

@customElement('ca-overall-count')
export class CaOverallCountElement extends LitElement {
  static override styles = [
    shoelaceStyles,
    styles,
    css`
      :host {
        color: var(--ca-color-highlight);
        display: contents;
      }
    `,
  ];

  private _controller!: SearchController;

  override connectedCallback() {
    log(this.constructor.name, 'connectedCallback');
    super.connectedCallback();

    this._controller = SearchController.instance(this);
  }

  override render() {
    return html`
      ${when(
      this._controller.data.json !== undefined,
      () => html`${(<any>this._controller.data.json).total}`,
      () => html`…`,
    )}
    `;
  }
}
